import { render, staticRenderFns } from "./bindedOrder.vue?vue&type=template&id=ff7e417a&scoped=true&"
import script from "./bindedOrder.vue?vue&type=script&lang=js&"
export * from "./bindedOrder.vue?vue&type=script&lang=js&"
import style0 from "./bindedOrder.vue?vue&type=style&index=0&id=ff7e417a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7e417a",
  null
  
)

export default component.exports